import {
  BarChart3,
  Calculator,
  CalendarCheck,
  FileText,
  IndianRupee,
  Package,
  PieChart,
  Receipt,
  TrendingUp,
  Wallet,
} from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { useWorkspace } from '../../context/WorkspaceContext';

const linkClass = ({ isActive }) =>
  `flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition ${
    isActive
      ? 'bg-blue-50 text-blue-700 border-l-4 border-blue-600'
      : 'text-slate-600 hover:bg-slate-100 border-l-4 border-transparent'
  }`;

function SectionLabel({ children }) {
  return (
    <p className="mt-4 mb-1 px-3 text-[10px] font-bold uppercase tracking-widest text-slate-400 lg:block hidden">
      {children}
    </p>
  );
}

export function Sidebar() {
  const { workspace, setWorkspace } = useWorkspace();

  return (
    <aside className="flex w-full shrink-0 flex-col border-b border-slate-200 bg-white lg:h-screen lg:w-64 lg:border-b-0 lg:border-r lg:overflow-y-auto">
      <div className="p-4">
        <label className="text-xs font-medium text-slate-500">Workspace</label>
        <select
          className="mt-1 w-full rounded-lg border border-slate-300 bg-white px-2 py-2 text-sm font-semibold text-slate-800"
          value={workspace}
          onChange={(e) => setWorkspace(e.target.value)}
        >
          <option value="Demo Company">Demo Company</option>
          <option value="Madras Sarees">Madras Sarees</option>
          <option value="My Company Ltd">My Company Ltd</option>
        </select>
      </div>
      <nav className="flex flex-row gap-1 overflow-x-auto px-2 pb-2 lg:flex-col lg:px-3 lg:pb-6">
        <NavLink to="/dashboard" end className={linkClass}>
          <BarChart3 className="h-4 w-4 shrink-0" />
          Overview
        </NavLink>
        <NavLink to="/dashboard/receivables" className={linkClass}>
          <BarChart3 className="h-4 w-4 shrink-0" />
          Receivables
        </NavLink>
        <NavLink to="/dashboard/payables" className={linkClass}>
          <BarChart3 className="h-4 w-4 shrink-0" />
          Payables
        </NavLink>

        <SectionLabel>MIS &amp; Reporting</SectionLabel>
        <NavLink to="/mis" className={linkClass}>
          <PieChart className="h-4 w-4 shrink-0" />
          MIS Report
        </NavLink>
        <NavLink to="/kpis" className={linkClass}>
          <TrendingUp className="h-4 w-4 shrink-0" />
          E-Com KPIs
        </NavLink>
        <NavLink to="/unit-economics" className={linkClass}>
          <IndianRupee className="h-4 w-4 shrink-0" />
          Unit Economics
        </NavLink>

        <SectionLabel>Planning</SectionLabel>
        <NavLink to="/cash-forecast" className={linkClass}>
          <Wallet className="h-4 w-4 shrink-0" />
          Cash Forecast
        </NavLink>
        <NavLink to="/inventory" className={linkClass}>
          <Package className="h-4 w-4 shrink-0" />
          Inventory
        </NavLink>
        <NavLink to="/finance-calendar" className={linkClass}>
          <CalendarCheck className="h-4 w-4 shrink-0" />
          Finance Calendar
        </NavLink>

        <SectionLabel>Operations</SectionLabel>
        <NavLink to="/bookkeeping" className={linkClass}>
          <FileText className="h-4 w-4 shrink-0" />
          Bookkeeping
        </NavLink>
        <NavLink to="/bills" className={linkClass}>
          <Receipt className="h-4 w-4 shrink-0" />
          Vendor bills
        </NavLink>
        <NavLink to="/gst" className={linkClass}>
          <Calculator className="h-4 w-4 shrink-0" />
          GST
        </NavLink>
      </nav>
    </aside>
  );
}
